import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { useAuth } from "../hooks/auth";
import ChangePassword from "../modules/accountUser/components/ChangePassword";
import EditAccount from "../modules/accountUser/components/EditAccount";

import Editor from "../modules/editor/screen";
import CheckoutScreen from "../modules/freeUser/CheckoutScreen";
import ErrorPage from "../modules/freeUser/ErrorPage";
import Login from "../modules/login/pages/Login";
import LoginLazy from "../modules/login/pages/LoginLazy";
import NewPassword from "../modules/login/pages/NewPassword";
import Master from "../modules/master/pages/Master";

import VerificationPaid from "../modules/Paiding/components/VerificationPaid";
import ForgotPasswordScreen from "../modules/register/components/ForgotPasswordScreen";
import RegisterScreen from "../modules/register/screen";
import SuspendedView from "../modules/suspendedUser/SuspendedView";
import RedirectRegistration from "../modules/RedirectRegistration";
import { ContractAnimation } from "../shared/components/ContractAnimation";

interface RoutesAppProps {
  unlockScreenMobile?: boolean;
  setUnlockScreenMobile?: React.Dispatch<React.SetStateAction<boolean>>;
  isPayment?: boolean;
  setIsPayment?: React.Dispatch<React.SetStateAction<boolean>>;
}

//routes app

export default function RoutesApp({
  unlockScreenMobile,
  setUnlockScreenMobile,
  isPayment,
  setIsPayment
}: RoutesAppProps) {
  const [loading, setLoading] = useState(false);
  const { data, typeUser, loadingTypeUser } = useAuth();

  // loading due to conflict between
  // login routes for getting the user to be asynchronous

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  //unlock for mobile public routes
  //for commit

  useEffect(() => {
    if (isPayment) {
      setUnlockScreenMobile(true);
    }

    if (data) {
      setUnlockScreenMobile(false);
    } else if (!data) {
      setUnlockScreenMobile(true);
    }
  }, [data, isPayment]);

  if (loading) {
    return (
      <div
        className="loading-application"
        id="pesss"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh"
        }}
      >
        {/* <LoadingEditor /> */}
        <ContractAnimation />
      </div>
    );
  }

  if (data && typeUser !== "Paid" && loadingTypeUser) {
    return (
      <div
        className="loading-application"
        id="pesss"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh"
        }}
      >
        <ContractAnimation />
      </div>
    );
  }

  return data ? (
    <Routes>
      {typeUser === "Paid" && (
        <>
          <Route path="/" element={<Master />} />
          <Route
            path="/editor/:typetemplate/:templateid"
            element={<Editor />}
          />
          <Route path="/perfil" element={<EditAccount />} />
          <Route path="/perfil/nova-senha" element={<ChangePassword />} />
          <Route path="*" element={<h1></h1>} />
          <Route path="/success" element={<VerificationPaid />} />
          <Route path="/suspenso" element={<SuspendedView />} />
          <Route path="/cadastro" element={<RedirectRegistration />} />
        </>
      )}

      {typeUser === "Unpaid" && (
        <>
          <Route
            path="/"
            element={
              <CheckoutScreen
                unlockScreen={unlockScreenMobile}
                setUnlockScreen={setUnlockScreenMobile}
                typeOfUser={typeUser}
                setTypeOfUser={typeUser}
              />
            }
          />
          <Route
            path="/editor/:typetemplate/:templateid"
            element={
              <CheckoutScreen
                unlockScreen={unlockScreenMobile}
                setUnlockScreen={setUnlockScreenMobile}
                typeOfUser={typeUser}
                setTypeOfUser={typeUser}
                isPayment={isPayment}
                setIsPayment={setIsPayment}
              />
            }
          />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/success" element={<VerificationPaid />} />
          <Route path="*" element={<span></span>} />
        </>
      )}

      {typeUser === "Suspended" && (
        <>
          <Route path="/" element={<SuspendedView />} />
          <Route
            path="/editor/:typetemplate/:templateid"
            element={<SuspendedView />}
          />
          <Route path="*" element={<h1></h1>} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/success" element={<VerificationPaid />} />
        </>
      )}
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/cadastro"
        element={
          <RegisterScreen isPayment={isPayment} setIsPayment={setIsPayment} />
        }
      />
      <Route path="/esqueci-minha-senha" element={<ForgotPasswordScreen />} />
      <Route path="/nova-senha/:token" element={<NewPassword />} />
      <Route path="/editor/:typetemplate/:templateid" element={<LoginLazy />} />
      <Route path="*" element={<h1></h1>} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/success" element={<VerificationPaid />} />
    </Routes>
  );
}
